module.exports = __webpack_public_path__ + "img/banner3.d3a977a.png";